export const PEOPLE_CODES = [
  { ID: 0, type: 'Seated', value: 0.8 },
  { ID: 1, type: 'Milling', value: 1 },
  { ID: 2, type: 'Active', value: 1.2 },
];
